import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { setMessage } from "../../redux/actions/message";
import OrderApi from "../../api/orderAPI";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import format from "../../helpers/format";
dayjs.extend(relativeTime);

const OrderEdit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  const { message, messageType } = useSelector((state) => state.message);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  useEffect(() => {
    (async () => {
      await OrderApi.getOrderDetail(id)
        .then((res) => {
          setOrder(res);
          setValue("orderStatus", res.orderStatus.status);
        })

      setLoading(false);
    })();
  }, [id]);

  const handleOnSubmit = async () => {
    const updateInfo = {
      ...order,
      orderStatus: { status: getValues("orderStatus") },
    };
    await OrderApi.updateOrder(id, updateInfo)
      .then(() => {
        dispatch(setMessage("Update successfully", "success"));
      })
      .catch((err) => {
        dispatch(setMessage(err, "danger"));
      });
  };

  return (
    <AuthLayout>
      <header
        className={"d-flex justify-content-between align-items-center mb-4"}
      >
        <h1>Order Edit</h1>
      </header>
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : order && Object.keys(order).length > 0 ? (
        <div>
          {message && (
            <div className="mb-4">
              <div className={`alert alert-${messageType}`} role="alert">
                {message}
              </div>
            </div>
          )}
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <div className="row mb-5">
              <div className="col-md-6">
                <dl className="row">
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Order ID</dt>
                  <dd className="col-sm-9 mb-2">{order._id}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Email</dt>
                  <dd className="col-sm-9 mb-2">{order.email}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Customer ID</dt>
                  <dd className="col-sm-9 mb-2">{order.customerId}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Item ID</dt>
                  <dd className="col-sm-9 mb-2">{order.itemId}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Price</dt>
                  <dd className="col-sm-9 mb-2">{format.formatCurrency(order.price)}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Quantity</dt>
                  <dd className="col-sm-9 mb-2">{order.quantity}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Subtotal</dt>
                  <dd className="col-sm-9 mb-2">{format.formatCurrency(order.subtotal)}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Total</dt>
                  <dd className="col-sm-9 mb-2">{format.formatCurrency(order.total)}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Invoice Number</dt>
                  <dd className="col-sm-9 mb-2">{order.invoiceNumber || <span className="text-muted">N/A</span>}</dd>
                </dl>
              </div>
              <div className="col-md-6">
                <dl className="row">
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Payment ID</dt>
                  <dd className="col-sm-9 mb-2">{order.paymentId}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Payment Status</dt>
                  <dd className="col-sm-9 mb-2">{format.formatPaymentStatus(order.paymentStatus)}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Order Type</dt>
                  <dd className="col-sm-9 mb-2 text-capitalize">
                    <span className={`badge rounded-pill bg-${order.orderType === 'single' ? 'primary' : 'info'} bg-opacity-10 text-${order.orderType === 'single' ? 'primary' : 'info'} fw-normal py-1 px-2`}>
                      {order.orderType}
                    </span>
                  </dd>
                  
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Created At</dt>
                  <dd className="col-sm-9 mb-2">{dayjs(order.created_at).format("YYYY-MM-DD HH:mm:ss")}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Valid Until</dt>
                  <dd className="col-sm-9 mb-2">{order.valid_until ? dayjs(order.valid_until).format("YYYY-MM-DD HH:mm:ss") : <span className="text-muted">N/A</span>}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Download URL</dt>
                  <dd className="col-sm-9 mb-2">{order.downloadUrl || <span className="text-muted">N/A</span>}</dd>
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Access Grant</dt>
                  <dd className="col-sm-9 mb-2">{order.accessGrant || <span className="text-muted">N/A</span>}</dd>
                  {order.updated_at && (
                    <>
                      <dt className="col-sm-3 fw-normal text-muted mb-2">Updated At</dt>
                      <dd className="col-sm-9 mb-2">{dayjs(order.updated_at).format("YYYY-MM-DD HH:mm:ss")}</dd>
                    </>
                  )}
                  <dt className="col-sm-3 fw-normal text-muted mb-2">Order Status</dt>
                  <dd className="col-sm-9 mb-2">
                    <select className="form-select form-select-sm" {...register("orderStatus")}> 
                      <option value="SUCCESS">Success</option>
                      <option value="PENDING">Pending</option>
                      <option value="FALSE">False</option>
                      <option value="DELETED">Deleted</option>
                    </select>
                  </dd>
                </dl>
              </div>
            </div>
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      ) : (
        <p>{"Not found"}</p>
      )}
    </AuthLayout>
  );
};

export default OrderEdit;
